import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HappyGuestSessionService } from '../happy/happy-guest-session.service';

@Injectable({ providedIn: 'root' })
export class WooCommerceCartTokenService {
  constructor(
    private happyGuestSessionService: HappyGuestSessionService
  ) {}

  getCartToken(): Observable<string> {
    return of(this.happyGuestSessionService.getOrCreateGuestSessionId());
  }

  refreshCartToken(): Observable<string> {
    return of(this.happyGuestSessionService.refreshGuestSessionId());
  }
}
